import React, { useEffect, useState } from "react";
import i18next from "i18next";
import { useTranslation } from "react-i18next";
import Cookies from "universal-cookie";
import { useSelector } from "react-redux";
import actions, { useActions } from "../../../../redux/actions";

const cookies = new Cookies();

const LanguageCurrencyChanger = () => {
  const { t, i18n } = useTranslation();

  const StoreConfig = useSelector((state) => state.storeConfig);
  const currencyData = useSelector((state) => state.currencyData);

  const CurrencyActions = useActions(actions.CurrencyActions);

  const [currency, setCurrency] = useState({
    support: ["HKD"],
    primary: "HKD",
  });
  const [locale, setLocale] = useState({
    support: ["en", "zh"],
    default: "en",
  });

  useEffect(() => {
    setCurrency(
      StoreConfig.currency || {
        support: ["HKD"],
        primary: "HKD",
      }
    );
    setLocale(
      StoreConfig.locale || {
        support: ["en", "zh"],
        default: "en",
      }
    );
  }, [StoreConfig]);

  const changeLanguageTrigger = (e) => {
    const languageCode = e.target.value;
    cookies.set("lang", e.target.value);
    i18next.changeLanguage(languageCode);
  };

  const setCurrencyTrigger = (e) => {
    const currencyName = e.target.value;
    CurrencyActions.setCurrency(
      currencyName,
      StoreConfig.exchangeRate[currencyName]
    );
  };

  const getLanguageDisplay = (lang) => {
    const langKey = lang || i18n.language.toLowerCase();
    switch (langKey) {
      case "en":
        return "English";
      case "zh":
        return "繁體中文";
      case "zh-hans":
        return "简体中文";
      case "zh-Hans":
        return "简体中文";
      case "es":
        return "Español";
      case "ko":
        return "한국어";
      case "ja":
        return "日本語";
      default:
        return "English";
    }
  };

  return (
    <div className="language-currency-wrap">
      <div className="same-language-currency language-style">
        <span>
          {getLanguageDisplay()}
          <i style={{ display: "none" }} className="fa fa-angle-down" />
        </span>
        <div className="lang-car-dropdown">
          <ul>
            <li>
              {Array.isArray(locale.support) &&
                locale.support.map((language) => (
                  <button
                    key={`lang_button_${language}`}
                    value={language}
                    onClick={changeLanguageTrigger}
                  >
                    {getLanguageDisplay(language)}
                  </button>
                ))}
            </li>
          </ul>
        </div>
      </div>
      <div className="same-language-currency use-style">
        <span>
          {currencyData?.currencyName
            ? currencyData.currencyName
            : currency.primary}
          {currencyData?.currencyName !== currencyData?.defaultCurrencyName && (
            <sup style={{ fontSize: 9, color: "red" }}>*</sup>
          )}
          <i className="fa fa-angle-down" />
        </span>
        <div className="lang-car-dropdown">
          <ul>
            {Array.isArray(currency.support) &&
              currency.support.map((currencyOption) => (
                <li key={`currency_item_${currencyOption.toLowerCase()}`}>
                  <button value={currencyOption} onClick={setCurrencyTrigger}>
                    {currencyOption}
                  </button>
                </li>
              ))}
          </ul>
        </div>
      </div>
      <div className="same-language-currency">
        {currencyData?.currencyName !== currencyData?.defaultCurrencyName && (
          <sub>
            <span style={{ color: "red" }}>*</span>
            {t("alerts.referencePriceRemarks")}
          </sub>
        )}
      </div>
    </div>
  );
};

export default LanguageCurrencyChanger;
